import React from 'react';
import PropTypes from 'prop-types';

export default class DetailsViewManagerComponent extends React.Component {
  constructor(props) {
    super(props);

    this.toggleVisibility = this.toggleVisibility?.bind?.(this);
    this.state = {};
  }

  componentDidMount() {
    this.setTableVisibility(false);
  }

  setTableVisibility(visibility) {
    const { setVisibility } = this.props;
    this.setState({ isDetailsVisible: visibility });
    setVisibility(visibility);
  }

  toggleVisibility() {
    const { isDetailsVisible } = this.state;
    this.setTableVisibility(!isDetailsVisible);
  }

  render() {
    const { ariaControls, title } = this.props;
    const { isDetailsVisible } = this.state;
    return (
      <button
        type="button"
        data-e2e="additional-info"
        className={`${isDetailsVisible ? 'active' : ''} els-btn els-btn-xs els-btn-link e2e-additional-info`}
        aria-controls={ariaControls}
        aria-expanded={isDetailsVisible}
        onClick={this.toggleVisibility}>
        <svg className="els-btn-icon els-btn-icon-tiny">
          <use xlinkHref={isDetailsVisible ? '#icon-chevron-up' : '#icon-chevron-down'} />
        </svg>
        <span>{title}</span>
      </button>
    );
  }
}

DetailsViewManagerComponent.propTypes = {
  title: PropTypes.string.isRequired,
  setVisibility: PropTypes.func.isRequired,
  ariaControls: PropTypes.string.isRequired,
};
